import React, { useMemo } from "react";
import { Button } from "@foundit/ui-library";
import UserProfile from "./UserProfile";
import useDownload from "../hooks/useDownload";
import BlinkingDot from "./BlinkingDot";
import { GenericDownload } from "@foundit/genericdownload/dist/GenericDownload.js";
import { getKnowledgeHubUrl } from "../utils/headerUtils";

interface IProps {
  userData: any;
  navDownloadIconRef?: any;
  middleware: string;
  showDrawer?: boolean;
}

const RightSection: React.FC<IProps> = ({
  userData,
  navDownloadIconRef,
  middleware,
  showDrawer
}) => {
  const { isDownloadOpen, setIsDownloadOpen, downloadsData } = useDownload({
    middleware,
  });


  const downloads = Object.values(downloadsData || {});
  const hasDownloads = downloads.length > 0;
  const isBlinkTrue = hasDownloads && downloads.some((d: any) => d.status === "InProgress");


  const currentUrl = typeof window !== "undefined" ? window.location.href : "";
  const knowledgeHubUrl = getKnowledgeHubUrl(currentUrl);

  // if not logged in
  if (!userData?.recruiter_id) {
    return null;
  }

  return (
    <div className="rec_header_rs_container">
      {/* Platform Guide */}
      <div className="rec_header_rs_pg">
        <div className="rec_header_rs_pg_child">
          <a href={knowledgeHubUrl} target="_blank" className="rec_header_ls_option_link">
            <Button
              size="small"
              type="text"
              startIcon={ <div className="RecHeaderSprite icons bulb" />}
              sx={{
                color: "inherit",
                backgroundColor: "transparent",
                height: "25px"
              }}
              // onClick={() => {
              //   if(typeof window !== "undefined"){
              //     window.open(knowledgeHubUrl, "_blank");
              //   }
              // }}
            >
              Platform Guide
            </Button>
          </a>
        </div>
      </div>

      {/* Download  */}
      <div className="rec_header_rs_dCta_wrapper">
        <div
          ref={navDownloadIconRef}
          style={{ display: "inline-flex", alignItems: "center" }}
        >
        <Button
          type="text"
          sx={{
            backgroundColor: "transparent",
            color: "inherit",
            cursor: downloads.length > 0 ? "pointer" : "not-allowed",
            padding: "0px",
            minWidth: "unset"
          }}
          startIcon={
            <div
              style={{ height: "24px", width: "24px" }}
              className="RecHeaderSprite icons download_black"
            />
          }
          // ref={navDownloa dIconRef}
          onClick={() => hasDownloads && setIsDownloadOpen(!isDownloadOpen)}
        >
          <></>
        </Button>
        </div>

        {downloads.length > 0 && <BlinkingDot isBlink={isBlinkTrue} />}

        {isDownloadOpen && (
          <GenericDownload
            isOpen={isDownloadOpen}
            onClose={() => setIsDownloadOpen(false)}
            data={{}}
          />
        )}
      </div>

      <div className="rec_header_rs_vertical_line" />

      {/* User Profile  */}
      <UserProfile userData={userData} knowledgeHubUrl={knowledgeHubUrl} showDrawer={showDrawer} />
    </div>
  );
};

export default React.memo(RightSection);
